import { useState, useEffect } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ROLE_LABELS = {
  admin: 'Administrador',
  rh: 'RH/Financeiro',
  gestor: 'Gestor',
};
export const ROLE_SHORT = { admin: 'ADM', rh: 'FIN', gestor: 'GEST' };

/** React hook returning the current user (or null while loading / on error). */
export function useCurrentUser() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/auth/me`, { withCredentials: true })
      .then((res) => { if (!cancelled) setUser(res.data); })
      .catch(() => { if (!cancelled) setUser(null); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { user, loading, role: user?.role || null };
}

export const isAdmin = (role) => role === 'admin';
export const canDeleteDefinitive = (role) => role === 'admin';
export const canViewPhotos = (role) => role === 'admin';
export const canArchiveEmployee = (role) => role === 'admin';
